<template>
  <div class="concept">
    <span>
      {{ item.name }}
    </span>
    <router-link
      v-if="canEdit"
      class="button is-link is-small"
      :to="`/concepts/edit/${item.id}`"
    >
      Edit
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    canEdit: {
      type: Boolean,
      default: true
    },
    item: Object
  }
};
</script>

<style lang="scss" scoped>
.concept {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
